import React, { useEffect, useState } from 'react';
import ShoppingPage from '../Components/Shopingcartpage/ShoppingPage';
import { useLocation } from 'react-router-dom';
import Header from '../Components/Header/Header';

// Optional: Your own preloader/spinner component or a simple inline loader
const Preloader = () => (
  <div style={{
    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
    display: 'flex', justifyContent: 'center', alignItems: 'center',
    backgroundColor: 'white', zIndex: 9999
  }}>
    <div className="spinner-border " style={{ width: '3rem', height: '3rem' , color: '#92ad69' }} role="status">
      <span className="sr-only">Loading...</span>
    </div>
  </div>
);

const ShoppingCart = () => {
  const [cartRefresh, setCartRefresh] = useState(false);
  const [loading, setLoading] = useState(true);

  const routePath = useLocation();

  const refreshCart = () => {
    setCartRefresh((prev) => !prev); // Toggle state to trigger refresh
  };

  const onTop = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    onTop();
  }, [routePath]);

  // Simulate a loading delay (adjust as needed)
  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 1500); // 1 second loader
    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      {loading && <Preloader />}
      <Header cartRefresh={cartRefresh} />
      <ShoppingPage onCartUpdate={refreshCart} />
    </>
  );
};

export default ShoppingCart;
